import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { STORAGE_NAME } from '../../core/constants/constants';
import jwt_decode from 'jwt-decode';
import {CookieService} from "@app/core/services/cookie.service";

@Component({
  selector: 'app-auth-callback',
  template: ''
})
export class AuthCallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      if (code) {
        this.authService.getAccessToken(code).subscribe(res => {
          const jwtDecode:any = jwt_decode(res.access_token);
          this.cookieService.set(STORAGE_NAME.ACCESS_TOKEN, res.access_token);
          this.cookieService.set(STORAGE_NAME.REFRESH_TOKEN, res.refresh_token);
          this.cookieService.set(STORAGE_NAME.EXPIRES_AT, `${Date.now() + res.expires_in * 1000}`);
          this.cookieService.set(STORAGE_NAME.USER_LOGIN,  JSON.stringify(jwtDecode['userInfo']));
          this.cookieService.set(STORAGE_NAME.ID_TOKEN,res.id_token);
          this.router.navigateByUrl('/').then();
        });
      }
    });
  }
}
